import { render, staticRenderFns } from "./OrderInfoProblem.vue?vue&type=template&id=0c111636&"
import script from "./OrderInfoProblem.vue?vue&type=script&lang=js&"
export * from "./OrderInfoProblem.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoProblem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderInfoProblem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports